/* eslint-disable max-len */
import { isObject } from 'lodash/fp';
import { useCallback } from 'react';
import { type UploadFileWithPreviewFormDataFragment } from '../../../../api/fragments/UploadFileWithPreviewFormData';
import { useDeleteVariantConfiguratorMatrixAssetMutation } from '../../../../api/mutations/deleteVariantConfiguratorMatrixAsset';
import { useUploadVariantConfiguratorMatrixAssetMutation } from '../../../../api/mutations/uploadVariantConfiguratorMatrixAsset';
import { MatrixAsset } from '../../../../api/types';

const useHandleColorMatrixAsset = () => {
    const [uploadColorMatrixAssetMutation] = useUploadVariantConfiguratorMatrixAssetMutation();
    const [deleteColorMatrixAssetMutation] = useDeleteVariantConfiguratorMatrixAssetMutation();

    const uploadColorMatrixAsset = useCallback(
        async (variantConfiguratorId: string, colorId: string, trimId: string, upload: File) => {
            const { data } = await uploadColorMatrixAssetMutation({
                variables: {
                    id: variantConfiguratorId,
                    colorId,
                    trimId,
                    type: MatrixAsset.ColorImage,
                    upload,
                },
            });

            return data?.variantConfigurator?.colorBlock;
        },
        [uploadColorMatrixAssetMutation]
    );

    const deleteColorMatrixAsset = useCallback(
        async (variantConfiguratorId: string, colorId: string, trimId: string) => {
            const { data } = await deleteColorMatrixAssetMutation({
                variables: {
                    id: variantConfiguratorId,
                    colorId,
                    trimId,
                    type: MatrixAsset.ColorImage,
                },
            });

            return data?.variantConfigurator?.colorBlock;
        },
        [deleteColorMatrixAssetMutation]
    );

    return useCallback(
        async (
            variantConfiguratorId: string,
            colorId: string,
            trimId: string,
            upload: File | UploadFileWithPreviewFormDataFragment,
            initialVariantColorImage?: UploadFileWithPreviewFormDataFragment
        ) => {
            if (upload instanceof File) {
                await uploadColorMatrixAsset(variantConfiguratorId, colorId, trimId, upload);
            }

            if (!upload && isObject(initialVariantColorImage)) {
                await deleteColorMatrixAsset(variantConfiguratorId, colorId, trimId);
            }
        },
        [deleteColorMatrixAsset, uploadColorMatrixAsset]
    );
};

export default useHandleColorMatrixAsset;
